export default __webpack_public_path__ + "static/media/Img0023.1e4c4046.png";